import React from 'react';
import { User } from '../../../../../entities/User';
import { Application } from '../../../../../entities/Application';
import { EmailEntry } from '../EmailEntry';
import { ApplicationFeedEmail } from '../../../../../entities/ApplicationFeed';
import { AccountIntegration } from '../../../../../entities/AccountIntegration';
import { AuthorName } from '../../AuthorName';
import { AlertObject } from '../../../../../components/Alert';

interface PropTypes {
  application: Application;
  applicationStylesPath: string;
  currentUser: User;
  emailAccountIntegration: AccountIntegration;
  entry: ApplicationFeedEmail;
  isLastItemInPage: boolean;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function EmailSentEntry(props: PropTypes) {
  return (
    <EmailEntry
      title={
        <>
          <AuthorName name={props.entry.authorName} /> sent{' '}
          <strong>{props.application.candidate.name}</strong> an email.
        </>
      }
      emailAccountIntegration={props.emailAccountIntegration}
      {...props}
    />
  );
}
